<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>

    <ion-title>
      {{ cardOnFile ? "Replace" : "Save" }} card for {{ client.firstName }}
      {{ client.lastName }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div *ngIf="cardOnFile && cardInfo">
    <b>Replacing card on file ending in: {{ cardInfo.last4 }}</b>
  </div>
  <div>
    <span>Enter the card to save:</span>
    <div class="card-element">
      <div #cardElement class="card-element-style"></div>
    </div>
    <div class="stripe-charge-buttons">
      <p *ngIf="errorMessage" class="text-align-center">{{ errorMessage }}</p>
    </div>
  </div>
  <div>
    <span class="smr-pale"
      >You should get signed authorization from the client to save their card
      and protect you from chargeback liability. Please have your customer fill
      out and sign
      <span
        tappable
        style="text-decoration: underline; font-weight: bold"
        (click)="onCardAuthorizationLink()"
        >this form</span
      >, then store it securely.</span
    >
  </div>
  <div *ngIf="cardErrors" class="smr-error-message-block text-align-center">
    {{ cardErrors }}
  </div>
</ion-content>

<ion-footer class="ion-no-border ion-no-margin">
  <ion-toolbar>
    <ion-row>
      <ion-col>
        <ion-button
          (click)="requestCardFromClient()"
          color="primary"
          expand="block"
          fill="outline"
        >
          Send request to client
        </ion-button>
      </ion-col>
      <ion-col>
        <ion-button
          (click)="saveCardOnFile()"
          color="primary"
          expand="block"
          ng-reflect-color="primary"
        >
          Save {{ cardOnFile ? "new " : "" }}card
          <span *ngIf="chargeAndSavePushed" class="padding-top-15">
            <salonmonster-small-checkmark-loader></salonmonster-small-checkmark-loader>
          </span>
        </ion-button>
      </ion-col>
    </ion-row>
  </ion-toolbar>
</ion-footer>
